<template>
  <div>
    <div v-if="props.data.totalScore" class="flex justify-center gap-2">
      <div v-if="props.data.totalScore >= 4.4" class="img-laurel-leaf-left" />

      <div class="text-center">
        <div class="font-semibold text-3xl leading-11">
          {{ formatNumber(props.data.totalScore) }}
        </div>
        <div class="text-xs md:text-tiny">
          Based on {{ props.data.ratings }} {{ data.ratings > 1 ? 'reviews' : 'review' }}
        </div>
      </div>

      <div v-if="props.data.totalScore >= 4.4" class="img-laurel-leaf-right" />
    </div>

    <ReviewModalStats :data="props.data" class="pt-2 mb-8" />
  </div>
</template>

<script setup>
import { defineProps } from 'vue';

import ReviewModalStats from './ReviewModalStats.vue';

const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
});

const formatNumber = (number) => {
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  }).format(number);
};
</script>

<style lang="scss" scoped>
.img-laurel-leaf-left {
  background-image: url('/img/icons/laurel-wreath-left.svg');
  width: 34px;
  height: 62px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.img-laurel-leaf-right {
  background-image: url('/img/icons/laurel-wreath-right.svg');
  width: 34px;
  height: 62px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
</style>
